/*eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import { graphql } from 'gatsby'
import axios from 'axios'
import styled from '@emotion/styled'
import { Layout } from 'components'
import * as Boxes from 'components/theme/Boxes'
import { SEO, Hero } from 'components/common'
import { PageWrapper, Section, RowSmallGap, Column3 } from 'components/theme/Layout'
import { Content, Headline } from 'components/theme/Content'
import { Badge } from 'components/theme'
import { SimpleBlock } from 'components/theme/Elements'
import ContactForm from 'components/forms/enseignes/ContactForm'
import AOS from 'aos';
import Snackbar from '@material-ui/core/Snackbar'
import { Notification } from 'components/common/alerts/SnackBars'

import meta from '../../config/meta.json'

const WallItem = styled.div`
  border-radius: 50%;
  border: 1rem solid ${props => props.theme.colors.lightBlue};
  overflow: hidden;
  img {
    margin: 0;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    max-width: 20rem;
    margin: 0 auto;
  }
`

const WallItemLabel = styled.div`
  text-align: center;
  margin-top: 2rem;
  span {
    display: block;
    line-height: 2rem;
    &:first-of-type {
      color: ${props => props.theme.colors.greyBlue};
      font-weight: 600;
    }
    &:last-of-type {
      color: ${props => props.theme.colors.grey};
      font-weight: 400;
      font-size: 1.4rem;
    }
  }
`

class MediaForGood extends React.Component {

  constructor() {
    super();
    this.state = {
      notification: false,
      loading: false
    }
  }

  componentDidMount() {
    AOS.init({
      duration: 1000,
      once: true
    })
  }


  getResults = values => {
    const { API_ENDPOINT } = this.props.pageContext;
    values.page = 'media-for-good';
    this.setState({ loading: true })
    axios.post(`${API_ENDPOINT}/user/contact/`, {
      values
    }).then(res => {
      if (res.data) {
        if (res.data.errors) {
          console.log('error');
        } else {
          this.setState({ loading: false, notification: true });
        }
      }
    })
  }

  handleCloseNotification = () => {
    this.setState({ notification: false })
  }

  UNSAFE_componentWillReceiveProps() {
    AOS.refresh();
  }

  render() {
    const { pageContext, location, data } = this.props;
    const hero = data.__backgrounds.edges.filter((item) => item.node.name === 'mediagood_header')[0].node;
    const illustrations = {
      'section1': data.__backgrounds.edges.filter((item) => item.node.name === 'mediagood_illu_1')[0].node,
      'section2': data.__backgrounds.edges.filter((item) => item.node.name === 'mediagood_illu_2')[0].node
    };
    const backgrounds = {
      'default': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_1')[0].node,
      'footer': data.__commonBackgrounds.edges.filter((item) => item.node.name === 'background_2')[0].node
    };

    return (
      <Layout context={pageContext} location={location}>
        <SEO title={meta.mediaForGood.title} description={meta.mediaForGood.description} />
        <Hero image={hero.publicURL}>
          <div className="card">
            <SimpleBlock>
              <Badge className="grey blue">Media for good</Badge>
            </SimpleBlock>
            <div>
              <h1>
                <span>Embarquez-vous dans une mission de bien commun</span>
              </h1>
            </div>
            <Content className="full padding xs">
              <p>
                Découvrez comment vous changez les choses en réalisant des campagnes avec Message in a Window.
              </p>
              <p style={{ paddingTop: '1.5rem' }}>
                Participez directement au Bien Commun tout en générant des performances rarement atteintes.
              </p>
            </Content>
          </div>
        </Hero>

        <PageWrapper>
          <Section className="no-margin">
            <Headline className="center padding l">
              <h2>
                <span>Vers le Bien Commun !</span>
              </h2>
              <p>
                <span>L'essentiel de nos actions en entreprises sont tournées vers
                la recherche de la performance économique</span>, c'est bien.
              </p>
              <p>
                Mais probablement pas suffisant dès lors qu'il devient possible
                pour un même euro investi d'allier performance <u>et</u> bien commun.
              </p>
            </Headline>
          </Section>

          <Section className="no-margin main" style={{
            background: `url(${illustrations.section2.publicURL})`,
            backgroundSize: '100rem',
            backgroundPosition: 'top right',
            backgroundRepeat: 'no-repeat no-repeat',
            padding: '20rem 0'
          }}>
            <div>
              <Boxes.BoxMedium className="cover" data-aos="fade-up">
                <div>
                  <Content>
                    <h3>Le Media For Good, le nouveau paradigme.</h3>
                    <p>
                      <span>Les Medias publicitaires sont souvent décriés car ils occupent tous les champs visuels</span> le plus souvent
                      au service d'une société consumériste où le sens est perdu.
                    </p>
                    <p>
                      Nous sommes une preuve qu'un autre modèle peut exister pour une vision au service
                      de l'homme et de son environnement.
                    </p>
                  </Content>
                </div>
              </Boxes.BoxMedium>
            </div>
          </Section>

          <Section className="no-margin main background-default" style={{
            backgroundImage: `url(${backgrounds.default.publicURL})`,
            backgroundPosition: 'bottom -50rem center',
            padding: '0 0 20rem'
          }}>
            <div>
              <Boxes.BoxLarge style={{ float: 'none', margin: '0 auto' }} data-aos="fade-up">
                <div>
                  <Content>
                    <h3>Nous irriguons les territoires d'un nouveau revenu.</h3>
                    <p>
                      <span>En communiquant en vitrines, nous redistribuons grâce à vous 35 à 40% de
                      chiffre d'affaires aux commerçants français.</span>
                    </p>
                    <p>
                      C'est un nouveau revenu auquel ils n'avaient pas accès qui leur offre l'opportunité
                      d'acheter du stock, recruter des employés, se fournir en matériels performants,
                      investir en digital, ou améliorer leur niveau de vie.
                    </p>
                  </Content>
                </div>
              </Boxes.BoxLarge>
            </div>

            <div>
              <Boxes.BoxLargeShadow style={{ float: 'none', margin: '0 auto' }} data-aos="fade-up">
                <div>
                  <Content>
                    <h2>Nous participons à vitaliser le commerce de proximité et à sauvegarder le lien social.</h2>
                    <p>
                      Les revenus que nous redistribuons aux commerçants grâce à vous stimulent le commerce de proximité,
                      font perdurer ces lieux d'échanges et préservent directement ces formidables espaces de lien social.
                    </p>
                  </Content>
                </div>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>

          <Section className="no-margin main" style={{
            background: `url(${illustrations.section1.publicURL})`,
            backgroundSize: 'contain',
            backgroundPosition: 'bottom left',
            backgroundRepeat: 'no-repeat',
            padding: '20rem 0 6rem'
          }}>
            <div className="right light">
              <Boxes.Box2Columns className="cover" data-aos="fade-down">
                <div>
                  <Content>
                    <h3>Nous participons à sanctuariser la valeur de notre patrimoine immobilier.</h3>
                    <p>
                      <span>Lien étonnant et pourtant bien réel. En créant ce nouveau revenu,
                      nous évitons de nombreuses fermetures de commerces.</span>
                    </p>
                    <p>
                      Nous évitons à des rues, des quartiers ou des communes d'être dévitalisés et aux habitations d'être
                      dépréciées.
                    </p>
                    <p>
                      Rien de moins attractif qu'un environnement sans commerce et sans vie.
                      Notre épargne à tous nous remercie.
                    </p>
                  </Content>
                </div>
              </Boxes.Box2Columns>
            </div>
          </Section>

          <Section className="no-margin">
            <Headline className="center padding l">
              <h2>
                <span>Rejoignez-nous !</span>
              </h2>
              <p>
                Si comme nous vous voulez promouvoir des actions pour le Bien Commun, <span>rejoignez-nous sur ce photo wall !</span>
              </p>
            </Headline>
            <RowSmallGap>
              {
                data.wall.edges.map((item, index) => {
                  if (index <= 3) {
                    return (
                      <Column3 key={`person${index}`}>
                        <WallItem>
                          <img src={item.node.publicURL} alt={`person${index}`} />
                        </WallItem>
                        <WallItemLabel>
                          <span>{item.node.name.split(', ')[0].replace('_', `'`)}</span>
                          <span>{item.node.name.split(', ')[1]}</span>
                        </WallItemLabel>
                      </Column3>
                    )
                  }
                })
              }
            </RowSmallGap>

            <RowSmallGap>
              {
                data.wall.edges.map((item, index) => {
                  if (index > 3 && index <= 7) {
                    return (
                      <Column3 key={`person${index}`}>
                        <WallItem>
                          <img src={item.node.publicURL} alt={`person${index}`} />
                        </WallItem>
                        <WallItemLabel>
                          <span>{item.node.name.split(', ')[0].replace('_', `'`)}</span>
                          <span>{item.node.name.split(', ')[1]}</span>
                        </WallItemLabel>
                      </Column3>
                    )
                  }
                })
              }
            </RowSmallGap>

            <RowSmallGap>
              {
                data.wall.edges.map((item, index) => {
                  if (index >= 8 && index <= 11) {
                    return (
                      <Column3 key={`person${index}`}>
                        <WallItem>
                          <img src={item.node.publicURL} alt={`person${index}`} />
                        </WallItem>
                        <WallItemLabel>
                          <span>{item.node.name.split(', ')[0].replace('_', `'`)}</span>
                          <span>{item.node.name.split(', ')[1]}</span>
                        </WallItemLabel>
                      </Column3>
                    )
                  }
                })
              }
            </RowSmallGap>

            <RowSmallGap>
              {
                data.wall.edges.map((item, index) => {
                  if (index >= 12) {
                    return (
                      <Column3 key={`person${index}`}>
                        <WallItem>
                          <img src={item.node.publicURL} alt={`person${index}`} />
                        </WallItem>
                        <WallItemLabel>
                          <span>{item.node.name.split(', ')[0].replace('_', `'`)}</span>
                          <span>{item.node.name.split(', ')[1]}</span>
                        </WallItemLabel>
                      </Column3>
                    )
                  }
                })
              }
            </RowSmallGap>
          </Section>

          <Section className="bottom main background-footer" style={{
            backgroundImage: `url(${backgrounds.footer.publicURL})`,
            padding: '0 0'
          }}>
            <div>
              <Boxes.BoxLargeShadow style={{ width: '100%' }}>
                <div>
                  <Content className="center">
                    <h2>Vos infos !</h2>
                    <ContactForm page="media-for-good" onSubmit={this.getResults} />
                    <Snackbar
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                      open={this.state.notification}
                      autoHideDuration={6000}
                      onClose={this.handleCloseNotification}
                    >
                      <Notification
                        onClose={this.handleCloseNotification}
                        variant="success"
                        message="Merci pour votre soutien, la cause est belle !"
                      />
                    </Snackbar>
                  </Content>
                </div>
              </Boxes.BoxLargeShadow>
            </div>
          </Section>
        </PageWrapper>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => ({
  ...state.contactForm
});
export default connect(mapStateToProps)(MediaForGood);

export const query = graphql`
  query {
    wall: allFile (filter: {relativeDirectory: {regex: "/wall/"}}) {
      edges {
        node {
          id,
          name,
          publicURL
        }
      }
    }
    __backgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "pages/media-for-good/svg"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
    __commonBackgrounds: allFile (
      filter: {
        relativeDirectory: {eq: "backgrounds/common"}
      }
    ) {
      edges {
        node {
          name,
          publicURL
        }
      }
    }
  }
`
/*eslint-enable */
